export default "__VITE_ASSET__XvTsOC7t__"